module.exports = __webpack_public_path__ + "img/mj4.4bdd48b4.png";